"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SmartTable = exports.SORT_ORDER_DESCENDING = exports.SORT_ORDER_ASCENDING = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _flow = _interopRequireDefault(require("lodash/flow"));

var _orderBy = _interopRequireDefault(require("lodash/orderBy"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _styles = require("@material-ui/core/styles");

var _TableSortLabel = _interopRequireDefault(require("@material-ui/core/TableSortLabel"));

var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));

var _RootRef = _interopRequireDefault(require("@material-ui/core/RootRef"));

var _reactResizeDetector = _interopRequireDefault(require("react-resize-detector"));

var _withPagination = _interopRequireDefault(require("../hoc/with-pagination"));

var _customTable = _interopRequireWildcard(require("./custom-table"));

var _flexTable = _interopRequireDefault(require("./flex-table"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SORT_ORDER_ASCENDING = 'asc';
exports.SORT_ORDER_ASCENDING = SORT_ORDER_ASCENDING;
var SORT_ORDER_DESCENDING = 'desc';
exports.SORT_ORDER_DESCENDING = SORT_ORDER_DESCENDING;

var styles = function styles(_ref) {
  var mixins = _ref.mixins,
      palette = _ref.palette,
      typography = _ref.typography;
  return {
    root: {
      backgroundColor: palette.background.paper
    },
    pagination: {
      borderTop: "1px solid ".concat(palette.divider),
      color: palette.text.secondary,
      fontSize: typography.pxToRem(12)
    },
    paginationCaption: _objectSpread({}, typography.caption),
    select: _objectSpread({}, mixins.flex('center', 'center')),
    tableContainer: {
      overflow: 'auto'
    },
    sortLabel: {
      '&:focus, &:hover': {
        color: palette.text.primary
      }
    },
    sortLabelIcon: {
      height: 18,
      width: 18,
      color: palette.text.secondary
    },
    table: {},
    tableHead: {},
    tableBody: {}
  };
};

var SmartTable =
/*#__PURE__*/
function (_Component) {
  _inherits(SmartTable, _Component);

  function SmartTable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SmartTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SmartTable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      orderBy: _this.props.initialOrderBy,
      order: _this.props.initialOrder,
      scrollbarWidth: 0
    });

    _defineProperty(_assertThisInitialized(_this), "tableBodyRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "sortRows", (0, _memoizeOne.default)(function (rows, orderByField, order) {
      return (0, _orderBy.default)(rows, [orderByField], [order]);
    }));

    _defineProperty(_assertThisInitialized(_this), "enrichColumns", (0, _memoizeOne.default)(function (columns, flex, areRowsExpandable) {
      var enrichedColumns = columns.map(_this.enrichColumn);

      if (flex && areRowsExpandable) {
        enrichedColumns.push(_this.expanderIconColumn);
      }

      return enrichedColumns;
    }));

    _defineProperty(_assertThisInitialized(_this), "expanderIconColumn", {
      props: {
        style: {
          width: 50,
          justifyContent: 'center'
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setScrollbarWidth", function () {
      var tableBody = _this.tableBodyRef.current;

      if (tableBody) {
        var clientWidth = tableBody.clientWidth || 0;
        var offsetWidth = tableBody.offsetWidth || 0;
        var scrollbarWidth = offsetWidth - clientWidth;

        _this.setState({
          scrollbarWidth: scrollbarWidth
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "enrichColumn", function (_ref2) {
      var property = _ref2.property,
          tooltip = _ref2.tooltip,
          sortable = _ref2.sortable,
          _ref2$header = _ref2.header,
          header = _ref2$header === void 0 ? {} : _ref2$header,
          rest = _objectWithoutProperties(_ref2, ["property", "tooltip", "sortable", "header"]);

      return _objectSpread({}, rest, {
        property: property,
        tooltip: tooltip,
        sortable: sortable,
        header: _objectSpread({}, header, {
          formatters: [_this.getHeaderSortingFormatter(property, tooltip, sortable)].concat(_toConsumableArray(header.formatters || []))
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getHeaderSortingFormatter", function (property, tooltip) {
      var sortable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return function (label) {
        var classes = _this.props.classes;

        if (!label) {
          return null;
        }

        var tooltipMessage = tooltip || label;

        if (!sortable) {
          return _react.default.createElement(_Tooltip.default, {
            title: tooltipMessage,
            placement: "bottom-start",
            enterDelay: 300
          }, _react.default.createElement("span", null, label));
        }

        return _react.default.createElement(_Tooltip.default, {
          title: tooltipMessage,
          placement: "bottom-start",
          enterDelay: 300
        }, _react.default.createElement(_TableSortLabel.default, {
          classes: {
            root: classes.sortLabel,
            icon: classes.sortLabelIcon
          },
          active: _this.state.orderBy === property,
          direction: _this.state.order,
          onClick: _this.createSortHandler(property)
        }, label));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getExpandableRowProps", function (rowData, extraFields) {
      var _this$props = _this.props,
          onRow = _this$props.onRow,
          expandableRowContentComponent = _this$props.expandableRowContentComponent;
      var rowProps = onRow ? onRow(rowData, extraFields) : {};
      return _objectSpread({}, rowProps, {
        rowData: rowData,
        expandableRowContentComponent: expandableRowContentComponent
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createSortHandler", function (property) {
      return function () {
        _this.setState(function (prevState) {
          return {
            orderBy: property,
            order: prevState.orderBy === property && prevState.order === SORT_ORDER_ASCENDING ? SORT_ORDER_DESCENDING : SORT_ORDER_ASCENDING
          };
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowsPerPageChange", function (_ref3) {
      var rowsPerPage = _ref3.target.value;

      _this.props.onRowsPerPageChange(rowsPerPage);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePageChange", function (event, page) {
      _this.props.onPageChange(page);
    });

    return _this;
  }

  _createClass(SmartTable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          rows = _this$props2.rows,
          rowsPerPage = _this$props2.rowsPerPage,
          autoAdjustPage = _this$props2.autoAdjustPage;
      var haveRowsChanged = prevProps.rows !== rows;
      var hasRowsPerPageChanged = prevProps.rowsPerPage !== rowsPerPage;

      if (haveRowsChanged || hasRowsPerPageChanged) {
        autoAdjustPage(rows);
      }
    }
  }, {
    key: "renderPagination",
    value: function renderPagination(sortedRows) {
      var _this$props3 = this.props,
          rowsPerPage = _this$props3.rowsPerPage,
          getValidPage = _this$props3.getValidPage,
          classes = _this$props3.classes,
          labelRowsPerPage = _this$props3.labelRowsPerPage,
          PaginationProps = _this$props3.PaginationProps;
      var page = getValidPage(sortedRows);

      var props = _objectSpread({
        page: page,
        rowsPerPage: rowsPerPage,
        labelRowsPerPage: labelRowsPerPage,
        count: sortedRows.length,
        classes: {
          root: classes.pagination,
          select: classes.select,
          caption: classes.paginationCaption
        },
        onChangePage: this.handlePageChange,
        onChangeRowsPerPage: this.handleRowsPerPageChange
      }, PaginationProps);

      return _react.default.createElement(_TablePagination.default, _extends({
        component: "div"
      }, props));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          flex = _this$props4.flex,
          rows = _this$props4.rows,
          onRow = _this$props4.onRow,
          onSort = _this$props4.onSort,
          rowKey = _this$props4.rowKey,
          columns = _this$props4.columns,
          classes = _this$props4.classes,
          paginate = _this$props4.paginate,
          paginateRows = _this$props4.paginateRows,
          itemPlaceholder = _this$props4.itemPlaceholder,
          TableHeadProps = _this$props4.TableHeadProps,
          TableProps = _this$props4.TableProps,
          expandableRowContentComponent = _this$props4.expandableRowContentComponent;
      var _this$state = this.state,
          orderByField = _this$state.orderBy,
          order = _this$state.order,
          scrollbarWidth = _this$state.scrollbarWidth;
      var areRowsExpandable = Boolean(expandableRowContentComponent);
      var enrichedColumns = this.enrichColumns(columns, flex, areRowsExpandable);
      var sortedRows = onSort ? onSort(rows, orderByField, order) : this.sortRows(rows, orderByField, order);
      var visibleRows = paginate ? paginateRows(sortedRows) : sortedRows;
      var Table = flex ? _flexTable.default : _customTable.default;
      var tableHeadStyle = flex ? {
        paddingRight: scrollbarWidth
      } : null;
      var expandableRows = flex && {
        expandableRows: areRowsExpandable
      };
      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement("div", {
        className: classes.tableContainer
      }, flex && _react.default.createElement(_reactResizeDetector.default, {
        handleHeight: true,
        handleWidth: true,
        onResize: this.setScrollbarWidth
      }), _react.default.createElement(Table, _extends({
        columns: enrichedColumns,
        classes: {
          root: classes.table
        }
      }, expandableRows, TableProps), _react.default.createElement(_customTable.TableHead, _extends({
        style: tableHeadStyle,
        classes: {
          root: classes.tableHead
        }
      }, TableHeadProps)), !itemPlaceholder && _react.default.createElement(_RootRef.default, {
        rootRef: this.tableBodyRef
      }, _react.default.createElement(_customTable.TableBody, {
        classes: {
          root: classes.tableBody
        },
        rowKey: rowKey,
        rows: visibleRows,
        onRow: areRowsExpandable ? this.getExpandableRowProps : onRow
      }))), itemPlaceholder), paginate && this.renderPagination(sortedRows));
    }
  }]);

  return SmartTable;
}(_react.Component);

exports.SmartTable = SmartTable;

_defineProperty(SmartTable, "defaultProps", {
  PaginationProps: {},
  TableHeadProps: {},
  TableProps: {},
  initialOrder: SORT_ORDER_ASCENDING,
  initialOrderBy: undefined,
  flex: false,
  rows: [],
  columns: [],
  onRow: undefined,
  onSort: undefined,
  expandableRowContentComponent: null,
  paginate: false,
  labelRowsPerPage: '',
  itemPlaceholder: null
});

process.env.NODE_ENV !== "production" ? SmartTable.propTypes = {
  autoAdjustPage: _propTypes.func.isRequired,
  classes: _propTypes.object.isRequired,
  getValidPage: _propTypes.func.isRequired,
  page: _propTypes.number.isRequired,
  paginateRows: _propTypes.func.isRequired,
  rowKey: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]).isRequired,
  rowsPerPage: _propTypes.number.isRequired,
  onPageChange: _propTypes.func.isRequired,
  onRowsPerPageChange: _propTypes.func.isRequired,
  PaginationProps: _propTypes.object,
  TableHeadProps: _propTypes.object,
  TableProps: _propTypes.object,
  columns: (0, _propTypes.arrayOf)(_propTypes.object),
  expandableRowContentComponent: _propTypes.func,
  flex: _propTypes.bool,
  initialOrder: (0, _propTypes.oneOf)([SORT_ORDER_ASCENDING, SORT_ORDER_DESCENDING]),
  initialOrderBy: _propTypes.string,
  itemPlaceholder: _propTypes.node,
  labelRowsPerPage: _propTypes.string,
  paginate: _propTypes.bool,
  rows: (0, _propTypes.arrayOf)(_propTypes.object),
  onRow: _propTypes.func,
  onSort: _propTypes.func
} : void 0;

var _default = (0, _flow.default)([_withPagination.default, (0, _styles.withStyles)(styles, {
  name: 'SmartTable'
})])(SmartTable);

exports.default = _default;